import React from 'react';
import ViewStatement from './ViewStatement';
import AuthService from '../services/AuthService';


const CandidateProfile = (props) => { 
  return (
    <ViewStatement StarId = {AuthService.getStarId()} />
  );
};

export default CandidateProfile;